import { jsx as _jsx } from "react/jsx-runtime";
// website/src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'process';
import App from './App';
import { isDevServer } from '@utils/isDevServer';
var root = ReactDOM.createRoot(document.getElementById('root'));
function renderApp() {
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { isDevServer: isDevServer() }) }));
}
if (isDevServer()) {
    console.log('index.tsx - loading dev environment');
}
renderApp();
